import { render, staticRenderFns } from "./integral_goods_edit.vue?vue&type=template&id=64590c2d&scoped=true"
import script from "./integral_goods_edit.vue?vue&type=script&lang=ts"
export * from "./integral_goods_edit.vue?vue&type=script&lang=ts"
import style0 from "./integral_goods_edit.vue?vue&type=style&index=0&id=64590c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64590c2d",
  null
  
)

export default component.exports